"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Search_exports = {};
__export(Search_exports, {
  default: () => Search_default
});
module.exports = __toCommonJS(Search_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.3867 13.0625L17.7852 16.4609C17.9284 16.6172 18 16.7995 18 17.0078C18 17.2161 17.9284 17.3919 17.7852 17.5352C17.6419 17.6784 17.4661 17.75 17.2578 17.75C17.0495 17.75 16.8672 17.6784 16.7109 17.5352L13.3125 14.1367C12.7786 14.5664 12.1732 14.9049 11.4961 15.1523C10.832 15.3867 10.1224 15.5039 9.36719 15.5039C8.49479 15.5039 7.66797 15.3346 6.88672 14.9961C6.11849 14.6706 5.44141 14.2214 4.85547 13.6484C4.28255 13.0625 3.83333 12.3789 3.50781 11.5977C3.16927 10.8294 3 10.0026 3 9.11719C3 8.24479 3.16927 7.41797 3.50781 6.63672C3.83333 5.86849 4.28255 5.19792 4.85547 4.625C5.44141 4.03906 6.11849 3.58333 6.88672 3.25781C7.66797 2.91927 8.49479 2.75 9.36719 2.75C10.2526 2.75 11.0794 2.91927 11.8477 3.25781C12.6289 3.58333 13.306 4.03906 13.8789 4.625C14.4518 5.19792 14.9076 5.86849 15.2461 6.63672C15.5846 7.41797 15.7539 8.24479 15.7539 9.11719C15.7539 9.8724 15.6302 10.5885 15.3828 11.2656C15.1484 11.9297 14.8164 12.5286 14.3867 13.0625ZM12.8633 12.5156C13.293 12.0859 13.6315 11.5781 13.8789 10.9922C14.1263 10.4062 14.25 9.78125 14.25 9.11719C14.25 8.45312 14.1198 7.82161 13.8594 7.22266C13.612 6.63672 13.2669 6.1224 12.8242 5.67969C12.3815 5.23698 11.8672 4.88542 11.2812 4.625C10.6823 4.3776 10.0443 4.25391 9.36719 4.25391C8.70312 4.25391 8.07161 4.3776 7.47266 4.625C6.88672 4.88542 6.3724 5.23698 5.92969 5.67969C5.48698 6.1224 5.13542 6.63672 4.875 7.22266C4.6276 7.82161 4.50391 8.45312 4.50391 9.11719C4.50391 9.79427 4.6276 10.4323 4.875 11.0312C5.13542 11.6172 5.48698 12.1315 5.92969 12.5742C6.3724 13.0169 6.88672 13.362 7.47266 13.6094C8.07161 13.8698 8.70312 14 9.36719 14C10.0312 14 10.6562 13.8763 11.2422 13.6289C11.8281 13.3815 12.3359 13.043 12.7656 12.6133C12.7786 12.6133 12.7852 12.6068 12.7852 12.5938C12.7982 12.5807 12.8112 12.5742 12.8242 12.5742C12.8242 12.5612 12.8307 12.5547 12.8438 12.5547C12.8568 12.5417 12.8633 12.5286 12.8633 12.5156Z",
      fill: "currentColor"
    }
  )
);
const SvgSearch = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Search_default = SvgSearch;
